export enum UserAccountRole {
  admin = 'admin',
  user = 'user',
}
